/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solution_Benefit_2Inputs */

const en_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go deeper anytime — read the original or even ask questions`)
};

const de_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du tiefer einsteigen willst, lies den Originaltext – oder stell einfach Fragen`)
};

const zh_tw_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想深入時，直接看到原文，甚至問問題`)
};

const zh_cn_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想深入时，直接看到原文，甚至问问题`)
};

const es_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si quieres profundizar, lee el texto original e incluso haz preguntas`)
};

const fr_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envie d'approfondir ? Accède au texte original, ou pose des questions`)
};

const it_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando vuoi approfondire, leggi il testo originale o fai domande`)
};

const pt_br_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer se aprofundar? Veja o original e até faça perguntas`)
};

const ja_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと知りたい時は原文も読めるし、質問もできる`)
};

const ko_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 알고 싶을 땐 원문도 바로 보고, 질문도 할 수 있어요`)
};

const ru_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда хочешь углубиться — читай оригинал и даже задавай вопросы`)
};

const th_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อยากรู้ลึกขึ้น ก็อ่านต้นฉบับ หรือถามคำถามได้เลย`)
};

const tr_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derinleşmek istersen orijinal metni gör, hatta soru sor`)
};

const ar_solution_benefit_2 = /** @type {(inputs: Solution_Benefit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما تريد التعمّق، عُد للنص الأصلي أو حتى اطرح أسئلة`)
};

/**
* | output |
* | --- |
* | "Go deeper anytime — read the original or even ask questions" |
*
* @param {Solution_Benefit_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const solution_benefit_2 = /** @type {((inputs?: Solution_Benefit_2Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solution_Benefit_2Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solution_benefit_2(inputs)
	if (locale === "de") return de_solution_benefit_2(inputs)
	if (locale === "zh_tw") return zh_tw_solution_benefit_2(inputs)
	if (locale === "zh_cn") return zh_cn_solution_benefit_2(inputs)
	if (locale === "es") return es_solution_benefit_2(inputs)
	if (locale === "fr") return fr_solution_benefit_2(inputs)
	if (locale === "it") return it_solution_benefit_2(inputs)
	if (locale === "pt_br") return pt_br_solution_benefit_2(inputs)
	if (locale === "ja") return ja_solution_benefit_2(inputs)
	if (locale === "ko") return ko_solution_benefit_2(inputs)
	if (locale === "ru") return ru_solution_benefit_2(inputs)
	if (locale === "th") return th_solution_benefit_2(inputs)
	if (locale === "tr") return tr_solution_benefit_2(inputs)
	return ar_solution_benefit_2(inputs)
});